<template><claim-list :risk-type="2"/></template>
<script>
import ClaimList from "./ClaimList.vue";
export default { name: "EmployerClaims", components: { ClaimList } };
</script>
